import styled from 'styled-components';

export const TimeBlock = styled.span`
  font-size: ${({ theme }) => theme.fs.sm};
  font-weight: 500;
  line-height:${({ theme }) => theme.spacing.x8};
  color: ${({ theme }) => theme.palette.primary};
  display: block;
`;
export const CityBlock = styled.span`
  font-size: ${({ theme }) => theme.fs.xxs};
  font-weight: 500;
  line-height:${({ theme }) => theme.spacing.x8};
  color: ${({ theme }) => theme.palette.primary};
  display: block;
`;
